import { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import HomepageContext from "./HomepageContext";

const HomepageProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [bestsell, setBestsell] = useState([]);
  const [selected, setSelected] = useState([]);
  const [successMessage, setSuccessMessage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
   const [cart, setCart] = useState(JSON.parse(sessionStorage.getItem('cart')) || []);
  const handleSnackbarClose = () => {
    setSuccessMessage(false);
  };

  //to show product list

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/product", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ComID: "EH25", Flag: "SF" }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setProducts(data.ProdLst || []);  
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

// to show best sell

useEffect(() => {
  const fetchBestsell = async () => {
    try {
      const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/product", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ComID: "EH25", Flag: "SB" }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setBestsell(data.ProdLst || []);  
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  fetchBestsell();
}, []);



//handle checkout

const handleCheckout = async () => {
  const userData = sessionStorage.getItem("user");
  const parsedData = JSON.parse(userData);

  if (!parsedData || !parsedData.AcntLst || parsedData.AcntLst.length === 0) {
    alert("User not found. Please log in again.");
    navigate("/login");
    return;
  }

  const sessionUser = parsedData.AcntLst[0];
  const cartData = JSON.parse(sessionStorage.getItem("cart")) || [];
  const selectedItems = cartData.filter((_, index) => selected.includes(index));

  if (selectedItems.length === 0) {
    alert("Please select items to checkout.");
    return;
  }

  const requestData = {
    Flag: "I",
    ComID: "EH25",
    UserID: sessionUser.UserID,
    ReferenceID: sessionUser.Username,
    AuthCode: sessionUser.AuthCode,
    Products: selectedItems.map(item => ({
      ProductID: item.ProdtID,
      MRPRate: item.ProdMrpPrice || 0,
      RetailRate: item.ProdRetailPrice || 0,
      PV: item.ProductPV || 0,
      Qty: item.quantity
    })),
  };

  console.log("📤 Checkout Request Payload:", JSON.stringify(requestData, null, 2));

  try {
    const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/transaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) throw new Error("Failed to place order");

    const result = await response.json();
    console.log("✅ Order Successful:", result);

    // Clear only the purchased items from cart
    const remainingItems = cartData.filter((_, index) => !selected.includes(index));
    sessionStorage.setItem("cart", JSON.stringify(remainingItems));
    setSelected([]);
    
    // Show success message and navigate to transactions
    setSuccessMessage(true);
    navigate("/transactions");

  } catch (error) {
    console.error("🚨 Checkout Error:", error);
    alert("Checkout failed. Please try again.");
  }
};

useEffect(() => {
  const storedCart = JSON.parse(sessionStorage.getItem("cart")) || [];
  if (JSON.stringify(storedCart) !== JSON.stringify(cart)) {
    setCart(storedCart);
  }
}, [successMessage]);  // ✅ Re-run when checkout is successful

  
  
  
  

    const [product, setProduct] = useState(location.state || JSON.parse(sessionStorage.getItem("productData")));
    const [quantity, setQuantity] = useState(1);

    const handleAddToCart = () => {
      const user = sessionStorage.getItem("user");
    
      if (!user) {
        sessionStorage.setItem("redirectAfterLogin", location.pathname);
        sessionStorage.setItem("productToAdd", JSON.stringify({ ...product, quantity }));
        navigate("/login");
        return;
      }
    
      let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
      const existingProductIndex = cart.findIndex((item) => item.ProdtID === product.ProdtID);
    
      if (existingProductIndex !== -1) {
        // Update quantity if product already exists
        cart[existingProductIndex].quantity += quantity;
      } else {
        // Add new product if it doesn't exist
        cart.push({ ...product, quantity });
      }
    
      sessionStorage.setItem("cart", JSON.stringify(cart));
      window.dispatchEvent(new Event("storage"));
      setSuccessMessage(true);
  };
  

  return (
    <HomepageContext.Provider value={{ products,bestsell,handleCheckout,selected, setSelected,successMessage,handleSnackbarClose,handleAddToCart,setSuccessMessage,product, setProduct,quantity,setQuantity }}>
      {children}
    </HomepageContext.Provider>
  );
};

export default HomepageProvider;
